import React from "react";
import Fade from "react-reveal/Fade";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function HeroSection() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const carouselImages = [
    "https://storage.googleapis.com/multi-web-assets/arcadia/arcadia-background.jpg",
  ];
  return (
    <section
      className="relative w-full h-full lg:min-h-[820px] min-h-[650px] bg-no-repeat flex flex-column items-center lg:justify-center justify-end antialiased overflow-hidden"
      style={{
        background: "linear-gradient(180deg, #83383B 40%, #243B55 100%)",
      }}
    >
      {/* Ellipse background image positioned on top */}

      <div className="flex items-center justify-start lg:pr-0 h-[100vh !important] w-full relative z-10">
        <div className="w-full h-full relative z-10">
          <Slider {...settings}>
            {carouselImages.map((image, index) => (
              <div key={index}>
                <div
                  style={{
                    backgroundImage: `url(${image})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat:"no-repeat",
                    height: "100vh",
                  }}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div style={{ height: "auto", padding: "60px 0px", zIndex: 20 }}>
        <div className="section-1-title">
          <h4 style={{ color: "white" }}>MOBILE GAMES</h4>
          <button className="btn-home-style">Lihat Semua</button>
        </div>
        {/* Game Grid */}
        <div className="section-1-grid">
          {/* Add your game cards here */}
          <div className="game-card">
            <img src="https://semutganteng.fra1.digitaloceanspaces.com/UniPlay/ad1427f3fe23204d0c1c90c7087e52fc.png" />
            <div>
              <h4>Mobile Legends</h4>
            </div>
          </div>
          <div className="game-card">
            <img src="https://semutganteng.fra1.digitaloceanspaces.com/UniPlay/f6438e1b33a2af20aa6821c12b840548.jpeg" />
            <div>
              <h4>PUBG</h4>
            </div>
          </div>
          <div className="game-card">
            <img src="https://semutganteng.fra1.digitaloceanspaces.com/UniPlay/f905467c126c2b272aee268a735a5d14.jpeg" />
            <div>
              <h4>Genshin Impact</h4>
            </div>
          </div>
          <div className="game-card">
            <img src="https://uniplay.id/cdn/b2ddd9fed988ada8888f11917574b42b-large.jpeg" />
            <div>
              <h4>Call of Duty Mobile</h4>
            </div>
          </div>
          <div className="game-card">
            <img src="https://semutganteng.fra1.digitaloceanspaces.com/UniPlay/54a9960aadb5de1938dec57081bdb642.png" />
            <div>
              <h4>Free Fire</h4>
            </div>
          </div>
          <div className="game-card">
            <img src="https://semutganteng.fra1.digitaloceanspaces.com/UniPlay/0e0502c3cc466b50f70897275b107376.jpeg" />
            <div>
              <h4>Honor of Kings</h4>
            </div>
          </div>
          <div className="game-card">
            <img src="https://semutganteng.fra1.digitaloceanspaces.com/UniPlay/ac7dbc6c7f97282313b7d1c9f18f8dee.jpeg" />
            <div>
              <h4>Valorant</h4>
            </div>
          </div>
          <div className="game-card">
            <img src="https://semutganteng.fra1.digitaloceanspaces.com/UniPlay/2622c2a5ae77cd676ba24370dfe578a5.jpeg" />
            <div>
              <h4>Honor of Kings</h4>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full px-56 py-36">
        <div className="flex-col w-full content-start justify-between">
          <h2 className="font-bold text-5xl">
            Flow Top Up: Solusi Terbaik Isi Ulang Game Mobile Anda!
          </h2>
          <p className="font-normal text-sm pt-6">
            Layanan top up cepat dan aman untuk berbagai game mobile favorit
            Anda. Dengan harga yang terjangkau dan proses yang mudah, kami hadir
            untuk memenuhi kebutuhan gaming Anda tanpa repot.
          </p>
          <button className="px-6 py-2 mt-6 text-white font-medium rounded-full bg-gradient-to-r from-cyan-400 to-gray-400 hover:from-cyan-500 hover:to-gray-500 shadow-lg">
            Get more details
          </button>
        </div>
      </div>
      <div style={{ height: "auto", display: "flex", flexDirection: "column" }}>
        <div className="hero-section-3">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3 style={{ fontSize: 26, fontWeight: "bold" }}>
              Lengkapi Koleksi Skin dan Item Premium di Game Favoritmu
            </h3>
            <span style={{ marginTop: 20, maxWidth: 600, textAlign: "center" }}>
              Vortex Top Up Gaming siap membantu kamu mendapatkan skin dan item
              premium terbaik untuk meningkatkan pengalaman bermain. Temukan
              pilihan top up khusus untuk Mobile Legends, Free Fire, PUBG
              Mobile, dan game lainnya. Dengan harga bersaing dan transaksi
              cepat, kini kamu bisa lengkapi koleksi skin tanpa ribet!
            </span>
          </div>
          <div class="masonry-grid">
            <div class="grid-item">
              <img
                src="https://storage.googleapis.com/urban-g-assets/bottom-promo-assets/promo-banner-one.jpg"
                alt="Image 1"
              />
            </div>
            <div class="grid-item">
              <img
                src="https://storage.googleapis.com/urban-g-assets/bottom-promo-assets/promo-banner-two.jpg"
                alt="Image 2"
              />
            </div>
            <div class="grid-item">
              <img
                src="https://storage.googleapis.com/urban-g-assets/bottom-promo-assets/promo-banner-three.jpg"
                alt="Image 3"
              />
            </div>
            <div class="grid-item">
              <img
                src="https://storage.googleapis.com/urban-g-assets/bottom-promo-assets/promo-banner-four.jpg"
                alt="Image 4"
              />
            </div>
            <div class="grid-item">
              <img
                src="https://storage.googleapis.com/urban-g-assets/bottom-promo-assets/promo-banner-five.jpg"
                alt="Image 5"
              />
            </div>
            <div class="grid-item">
              <img
                src="https://storage.googleapis.com/urban-g-assets/bottom-promo-assets/promo-banner-six.jpg"
                alt="Image 6"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
